const nutritionalMapping = {
  9: 'Calorie totali (kcal)',
  10: 'Carboidrati',
  11: 'Grassi',
  12: 'Proteine',
  13: 'Zuccheri',
  14: 'Sale',
  15: 'Pepe',
  // Add more mappings if needed
}

export default nutritionalMapping
